import React from "react";
import {ControlLabel, FormControl, Radio, Button} from "react-bootstrap";
import DatePicker from "react-bootstrap-date-picker";
import {browserHistory} from "react-router";
import context from "../../lib/context.js";
import TimecardList from "../shared/timecard-list2.jsx";
import moment from 'moment';
import WeekPicker from "../shared/week-picker.jsx";
import SendSubmitTimecardReminder from "../shared/send-submit-timecard-reminder";
import PayrollStaffAutoComplete from "../shared/payroll-staff-autocomplete.jsx";

export default class SearchForm2 extends React.Component {
    constructor(props) {
        super(props);      
        
        this.state = {
            showSubmitTimecardDialog: false,
            submitTimecardId: 0,
            office: '',
            associateName: '',
            peopleName: ''
        };
        
        this.onFieldChange = this.onFieldChange.bind(this);      
        this.countSelectedItem = this.countSelectedItem.bind(this);
        this.updateTextFields = this.updateTextFields.bind(this);
        this.inputs = {};
        this.toggleSubmitTimecardDialog = this.toggleSubmitTimecardDialog.bind(this);
        this.submitTimecardAfterSend = this.submitTimecardAfterSend.bind(this);
    }

    componentDidUpdate() {
        const self = this;
    }

    toggleSubmitTimecardDialog(show, timecardId, peopleName) {
        this.setState({
            showSubmitTimecardDialog: show,
            submitTimecardId: timecardId,
            peopleName: peopleName
        });
    }

    submitTimecardAfterSend(timecardId) {
        let timecardList = this.props.vm.timecardList;
        let timecard = timecardList.timecards.filter(x => x.timecardSummary.timecardId == parseInt(timecardId));

        if (timecard.length) {
            timecardList.timecards[timecardList.timecards.indexOf(timecard[0])].timecardSummary.submitReminder = true;
        }

        var patch = {
            timecardList : timecardList
        };
        this.props.onFieldChange({search: patch});
    }

    onFieldChange(fieldName, value, callback) {       
        var patch = {
            [fieldName] : value
        };        
        this.props.onFieldChange({search: patch}, callback);
    }
        
    updateTextFields(callback) {
        var patch = {
            associateName : this.inputs.associateName.value,
            office: this.inputs.office.value
        };        
        this.props.onFieldChange({search: patch}, callback);
    }

    countSelectedItem() {
        try {
            let count = 0;
            let vm = this.props.vm;
            for(let i = 0; i < vm.timecardList.timecards.length; i++) {
                let tc = vm.timecardList.timecards[i].timecardSummary;                
                if (tc.isChecked && !(tc.isEdited || tc.isIncomplete)) count ++;
            }

            return count;
        } catch(e) {
            console.log(e);
            return 0;
        }
    }

    render() {  
        const self = this;
        let vm = this.props.vm;        
        let companies = [];        
        let offices = [];
        if (vm != null) {          
            companies.push(
                <option key="all" value="">All</option>
            );

            if (vm.companies != null) {
                for(var i = 0; i< vm.companies.length; i++) {
                    if (vm.companies[i] !== "") {
                        companies.push(
                                <option key={vm.companies[i]} value={vm.companies[i]}>{vm.companies[i]}</option>
                            );
                    }
                }
            }

            offices.push(<option key="all" value="">All</option>)

            if (vm.offices != null) {
                for (var i = 0; i < vm.offices.length; i++) {
                    offices.push(
                        <option key={vm.offices[i]} value={vm.offices[i]}>{vm.offices[i]}</option>
                    );
                }
            }
            
            let currentWeekEndingDate = moment(vm.currentWeekEndingDate).format("MM/DD/YYYY");
            let weekEndingDate = moment(vm.weekEndingDate).format("MM/DD/YYYY");

            let totalPage = vm.timecardList.total / vm.pageSize + 
            (vm.timecardList.total % vm.pageSize > 0 ? 1 : 0);        
            let verifyTcButtonClass = "ap-fullsize ";
            let verifyTcButtonDisabled = false;
            if (this.countSelectedItem() > 0) verifyTcButtonClass += "btn-info";
            else verifyTcButtonDisabled = true;

            return(            
                <div className="container">
                    <SendSubmitTimecardReminder 
                        show={this.state.showSubmitTimecardDialog}
                        toggleDialog={this.toggleSubmitTimecardDialog}
                        afterSend={this.submitTimecardAfterSend}
                        role={this.props.role}
                        timecardId={this.state.submitTimecardId}
                        vm={this.props.vm} 
                        peopleName={this.state.peopleName}>
                    </SendSubmitTimecardReminder>             
                    <div className="row">
                        <div className="col-md-3">
                            <ControlLabel>Staff Name:</ControlLabel>
                            <PayrollStaffAutoComplete
                                id="staff" 
                                items={this.props.peopleList}
                                defaultValue=""
                                onChange={this.onFieldChange}
                                onSearch={this.props.onSearch} />
                        </div>
                        <div className="col-md-9 ap-no-padding-left">
                            <div className="col-md-5 ap-no-padding-left">
                                <div>
                                    <span><ControlLabel>Week Ending Date:</ControlLabel></span>
                                    <span className="ap-float-right ">
                                        <a href="#" title={currentWeekEndingDate} 
                                            onClick={(evt) => { 
                                                evt.preventDefault();
                                                if (currentWeekEndingDate != weekEndingDate) {
                                                    this.onFieldChange("weekEndingDate", new Date(evt.target.title), this.props.onSearch);
                                                }   
                                                return false;
                                            }} className={"ap-link-small ap-view-current-week " + (currentWeekEndingDate == weekEndingDate ? 'current-week' : '')}>View Current Week</a>
                                    </span>
                                </div>
                                <WeekPicker id="week" vm={this.props.vm} onFieldChange={this.onFieldChange}
                                    onSearch={this.props.onSearch}>
                                </WeekPicker>
                            </div>     
                            <div className="col-md-3 ap-no-padding-left">
                                <ControlLabel>Status:</ControlLabel>
                                <FormControl componentClass="select" defaultValue=""
                                    onChange={(evt) => this.onFieldChange("status", evt.target.value, this.props.onSearch)}>
                                    <option key="all" value="all">All</option>
                                    <option key="Submitted" value="Submitted">Submitted</option>
                                    <option key="Saved" value="Saved">Unsubmitted</option>
                                    <option key="Approved" value="Approved">Verified</option>
                                    <option key="Processed" value="Processed">Processed</option>
                                    {/* <option key="Purge" value="Purge">Purge</option> */}
                                </FormControl>
                            </div>
                            <div className="col-md-2 ap-no-padding-left">
                                <ControlLabel>Office:</ControlLabel>
                                <FormControl id="office" componentClass="select" 
                                    value={vm.office} onChange={(evt) => this.onFieldChange("office", evt.target.value, this.props.onSearch)}>
                                    {offices}
                                </FormControl>
                            </div>
                            <div className="col-md-2 ap-no-padding-left">
                                <ControlLabel>Company:</ControlLabel>
                                <FormControl componentClass="select" 
                                value={vm.company} onChange={(evt) => this.onFieldChange("company", evt.target.value, this.props.onSearch)}>
                                    {companies}
                                </FormControl>
                            </div>  
                        </div>         
                    </div>
                    <div className="row">
                        <div className="col-md-12">                            
                            <TimecardList vm={vm.timecardList} totalPage={totalPage} page={vm.page} 
                                onNavigate={this.props.onNavigate}                            
                                onTcItemChecked={this.props.onTcItemChecked} role={this.props.role}
                                toggleSubmitTimecardDialog={this.toggleSubmitTimecardDialog}
                                showSubmitTimecardDialog={this.state.showSubmitTimecardDialog}
                                onSortChange={this.props.onSortChange} onSearch={this.props.onSearch}
                                sortExpression={vm.sortExpression} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <Button className={verifyTcButtonClass} onClick={() => {
                                    self.updateTextFields(() => self.props.onVerify());
                                }}
                                disabled={verifyTcButtonDisabled}>Verify Selected Timecards</Button>
                        </div>
                    </div>                    
                </div>
                );            
        } else {
            return(
                <div className="container">
                    <div className="row">
                        
                    </div>
                </div>
                );
        }
    }
}